import { render, staticRenderFns } from "./MonitoringRestrainDetail.vue?vue&type=template&id=176c4d08&scoped=true&"
import script from "./MonitoringRestrainDetail.vue?vue&type=script&lang=ts&"
export * from "./MonitoringRestrainDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MonitoringRestrainDetail.vue?vue&type=style&index=0&id=176c4d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c4d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
